import script from "./IncompatibleBrowserService.vue?vue&type=script&setup=true&lang=ts"
export * from "./IncompatibleBrowserService.vue?vue&type=script&setup=true&lang=ts"

import "./IncompatibleBrowserService.vue?vue&type=style&index=0&id=004c9272&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-004c9272"]])

export default __exports__